import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

import css from "./empty.module.scss";

const EmptyActicities = ({ t }) => (
  <div className={css.root}>
    <strong>{t("results.noActivitiesFound")}</strong>
    <p>{t("results.tryChangingSearch")}</p>
  </div>
);

const EmptyActivitiesWithTranslation = withTranslation("search")(EmptyActicities);
export default EmptyActivitiesWithTranslation;

EmptyActicities.propTypes = {
  t: PropTypes.func
};
